export default "__VITE_ASSET__Cs5iXEcq__"